<template>
<v-app dark>
    <v-toolbar >
      <v-btn v-if="backArrow === 0" icon v-on:click="onBack()">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <img src="./assets/talkr-logo.png" height=40px>
      <v-spacer></v-spacer>
      <v-btn icon @click="rightDrawer = !rightDrawer">
        <v-icon>menu</v-icon>
      </v-btn>
    </v-toolbar>
    <v-navigation-drawer
      temporary
      v-model="rightDrawer"
      right
      fixed
      app
      touchless
    >
    <v-list>

        <v-list-tile @click="login()" :disabled="$router.currentRoute.name == 'login'">
          <v-list-tile-action>
            <v-icon>account_circle</v-icon>
          </v-list-tile-action>
          <v-list-tile-title v-if="user && !user.isAnonymous">Logout: {{user.displayName}}</v-list-tile-title>
          <v-list-tile-title v-else>Login</v-list-tile-title>
        </v-list-tile>

        <v-list-tile @click="GoToDestination(`content`)" :disabled="$router.currentRoute.name == 'content'">
          <v-list-tile-action>
            <v-icon>movie</v-icon>
          </v-list-tile-action>
          <v-list-tile-title >Content</v-list-tile-title>
        </v-list-tile>

        <v-divider inset></v-divider>

         <v-list-tile @click="GoToDestination(`privacy`)" :disabled="$router.currentRoute.name == 'privacy'">
          <v-list-tile-action>
            <v-icon>security</v-icon>
          </v-list-tile-action>
          <v-list-tile-title >Privacy</v-list-tile-title>
        </v-list-tile>

         <v-list-tile @click="GoToDestination(`tos`)" :disabled="$router.currentRoute.name == 'tos'">
          <v-list-tile-action>
            <v-icon>warning</v-icon>
          </v-list-tile-action>
          <v-list-tile-title >Terms of Service</v-list-tile-title>
        </v-list-tile>

         <v-list-tile @click="GoToDestination(`about`)" :disabled="$router.currentRoute.name == 'about'">
          <v-list-tile-action>
           <v-icon>question_answer</v-icon>
          </v-list-tile-action>
          <v-list-tile-title >About</v-list-tile-title>
        </v-list-tile>

         <v-list-tile href="https://talkr-app.github.io/smooth-script/" target="_blank">
          <v-list-tile-action>
           <v-icon>help</v-icon>
          </v-list-tile-action>
          <v-list-tile-title >Smooth Script Docs</v-list-tile-title>
        </v-list-tile>
    </v-list>
    </v-navigation-drawer>
   <div id="app">
     <!--
       https://stackoverflow.com/questions/41301099/do-we-have-router-reload-in-vue-router
       Refresh when path changes
     -->
    <router-view :key="$route.fullPath"></router-view>
  </div>

</v-app>
</template>

<style>
  @import './css/style.css';
</style>

<script>
import firebase from 'firebase/app'
export default {
  name: 'App',
  data () {
    return {
      user: firebase.auth().currentUser,
      fixed: true,
      rightDrawer: false,
      backArrow: 1
    }
  },
  created: function () {
    firebase.auth().onAuthStateChanged((changeduser) => {
      this.user = changeduser
      this.$store.dispatch('main/login').then(() => {
        this.$store.dispatch('main/initialize')
      })
    })
  },
  methods: {
    GoToDestination: function (link) {
      this.$router.push({ path: '/' + link })
    },
    login: function () {
      if (this.user && !this.user.isAnonymous) {
        // localStorage.clear()
        firebase.auth().signOut().then(() => {
          this.$router.push({ path: `/` })
        })
      }
      this.$router.push({path: '/login'})
      this.rightDrawer = false
    }
  }
}
</script>

<style>

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue